// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"main-module--mainContainer--3YoBw"};